import Echarts from "echarts";
import getJson, { calculation } from "@/method";
const color = ['#C4BD97', '#F79646', '#FF2500', '#C01900', '#92D050', '#000000', '#45A1B9', '#98747F', '#3DCFC5', '#62AAA3', '#6AF910', '#948A54', '#984808', '#9F2397', '#B3A2C7'];


export const setKarte = ({
    dataX = new Array(12).fill(1).map((x, i) => `${i + 1}月`),
    dataY, id, title, yAxis, axisLabel
}, isOnResize) => {
    const myChart = Echarts.init(document.getElementById(id));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        color,
        title: {
            text: title
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
        },
        grid: {
            top: 120,
        },
        legend: {
            top: 30,
            data: dataY.map(x => x.name)
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    show: true
                }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisLabel: {
                    color: "black",
                    fontSize: 14,
                    ...axisLabel
                },
                data: dataX
            }
        ],
        yAxis: yAxis || [
            {
                type: 'value',
                name: '',
                axisLabel: {
                    formatter: '{value}'
                },

            },
            {
                type: 'value',
                name: '',
                axisLabel: {
                    formatter: '{value} %'
                }
            }
        ],
        series: dataY.map((x, i) => {
            return {
                name: x.name,
                type: x.type && x.type == 'percent' ?
                    "line" : 'bar',
                data: x.data,
                yAxisIndex: x.type === "percent" ? 1 : 0,
            }
        }),
    }

    myChart.setOption(option);
}


export const compute = data => {

    data.forEach((hotel, i) => {
        data[i].data = Array.prototype.slice.call(hotel.data).map(item => {
            return {
                ...item,
                revper: calculation(item.rev, item.total, 2),
                occ: (calculation(item.sold, item.ava, 3) * 100).toFixed(1),
                adr: calculation(item.rev, item.sold, 2),
                revpar: calculation(item.rev, item.ava, 2),
            }
        });
        data[i].lastdata = Array.prototype.slice.call(hotel.lastdata).map(item => {
            return {
                ...item,
                revper: calculation(item.rev, item.total, 2),
                occ: (calculation(item.sold, item.ava, 3) * 100).toFixed(1),
                adr: calculation(item.rev, item.sold, 2),
                revpar: calculation(item.rev, item.ava, 2),
            }
        });
    });

    return data
} 


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/regionalReport/year/compute.js